import { useState, useEffect, useRef } from "react";
import { getCookie } from "../utils/cookieUtils";

function useBatchStudyInfo(props) {
  const username = getCookie("X-Spl-Username-Header");
  const [batchName, setBatchName] = useState("");
  const [batchType, setBatchType] = useState("");
  const [batchId, setBatchId] = useState("");
  const [studyName, setStudyName] = useState("");
  const [fileNumber, setFileNumber] = useState(0);
  const [leftLevel, setLeftLevel] = useState("");
  const [rightLevel, setRightLevel] = useState("");
  const [id, setIdNumber] = useState(0);
  const [low_rating_options, setLowratingOptions] = useState([]);
  const [rating_error_level, setRatingErrLevel] = useState(0);
  const [rating_severity, setRatingSeverity] = useState([]);
  const [instruction, setInstruction] = useState("");
  const[audio_file_url, setAudioFileUrl] = useState("");
  const[audio_file_id, setAudioFileId] = useState("");
  const[audio_transcription, setAudioFileText] = useState("");
  const[isUserAdmin, setUserAdmin] = useState("");
  const[total_file_count, setTotalFileCount] = useState(0);
  const[total_rated_file_count, setTotalRatedFileCount] = useState(0);
  const maxBackPresses = 1; // maximum number of times back can be pressed continuously
  const [backPresses, setBackPresses] = useState(0);

  useEffect(() => {
    if (props.batchId.length > 0) {    
    const delay = 1000;
    const url = `${process.env.REACT_APP_API_URL}/percept_db/v1/audio?type=batch-details&id=` + props.batchId;
    console.log("url: ", url);
    const timerId = setTimeout(() => {
    fetch(url , {
      method: 'GET',
      headers: {
        'X-Spl-Username-Header': username,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setBatchName(data.data.batch_details.batch_name);
        setBatchType(data.data.batch_details.batch_type);
        setBatchId(data.data.batch_details.batch_id);
        setStudyName(data.data.batch_details.study_name);
        setFileNumber(
          data.data.batch_details.audio_file_details[0].audio_file_number
        );
        setLeftLevel(data.data.batch_details.rating_category.left_level);
        setRightLevel(data.data.batch_details.rating_category.right_level);
        setLowratingOptions(data.data.batch_details.low_rating_options);
        setRatingErrLevel(data.data.batch_details.rating_error_level);
        setRatingSeverity(data.data.batch_details.rating_severity);
        setInstruction(data.data.batch_details.batch_instruction);
        setAudioFileUrl(data.data.batch_details.audio_file_details[0].audio_file_url);
        setAudioFileId(data.data.batch_details.audio_file_details[0].audio_file_id);
        setAudioFileText(data.data.batch_details.audio_file_details[0].audio_transcription);
        setUserAdmin(data.data.end_user_type);
        setTotalFileCount(data.data.batch_details.total_file_count);
        setTotalRatedFileCount(data.data.batch_details.total_rated_file_count);
      })
      .catch((error) => console.log("Excepted!"));
    }, delay);

    return () => {
      clearTimeout(timerId);
    }
    }
  }, [props.batchId, username, id]);

  const updateId = useRef(() => {
    // this is not currently being used, this is only workaround
    setIdNumber((prevIdNumber) => prevIdNumber + 1);
    setBackPresses(0);
  });

  const backId = useRef(() => {
    if (backPresses < maxBackPresses) {
      setIdNumber((prevIdNumber) => prevIdNumber - 1);
      setBackPresses((prevBackPresses) => prevBackPresses + 1); // increment back presses
    }
  });

  useEffect(() => {
    console.log("fileNumber is ", fileNumber);
  }, [fileNumber]);

  return {
    batchName,
    batchType,
    batchId,
    studyName,
    fileNumber,
    leftLevel,
    rightLevel,
    low_rating_options,
    rating_error_level,
    rating_severity,
    instruction,
    audio_file_url,
    audio_file_id,
    audio_transcription,
    isUserAdmin,
    total_file_count,
    total_rated_file_count,
    updateId: updateId.current,
    backId: backPresses < maxBackPresses ? backId.current : null,
  };
}

export default useBatchStudyInfo;
